import { NavIdsEnum } from '@components/header-landing/constants';
import Icon from '@components/icons';
import * as Styles from '@screens/lp-default/components/plans-banner/styles';
import { useHandleLPScroll } from '@screens/hooks/use-handle-lp-scroll';
import { OffersModel } from '@remote-data/load-offers/types';
import { snowplowButtonClick } from '@analytics/snowplow/events';

type PlansBannerProp = {
  offers: OffersModel;
};

export default function PlansBanner({ offers }: PlansBannerProp) {
  const { handleScrollTo } = useHandleLPScroll();

  const handlePlansButtonClick = () => {
    snowplowButtonClick('about_subscription', '/planos', null, 'plans_banner');
    handleScrollTo(NavIdsEnum.PLANS);
  };

  const handleCheckoutButtonClick = () => {
    const planId = 'whitebook_anual_2021';
    snowplowButtonClick('subscribe_button', '/planos', null, 'plans_banner');
    window.location.href = `${process.env.NEXT_PUBLIC_PAYMENT_METHOD_CHECKOUT}?planid=${planId}&utm_source=${process.env.NEXT_PUBLIC_APP_CODE_BACKEND}`;
  };

  const getDiscountedTotal = () => {
    const annualPlan = offers?.planList.find((plan) => plan.splittable === false && plan.period === 'annually');
    return annualPlan.price.total;
  };

  return (
    offers && (
      <Styles.Container data-testid="plans-banner">
        <Styles.Background>
          <source media="(max-width: 663px)" srcSet="/images/bg-plans-banner-mobile.webp" />
          <source media="(min-width: 664px) and (max-width: 1023px)" srcSet="/images/bg-plans-banner-tablet.webp" />
          <source media="(min-width: 1024px)" srcSet="/images/bg-plans-banner-desktop.webp" />
          <img src="/images/bg-plans-banner-tablet.webp" alt="Fundo banner de planos" />
        </Styles.Background>
        <Styles.Content>
          <Styles.DescriptionWrapper>
            <Styles.Title>
              Junte-se a mais de 160 mil médicos e tenha acesso a principal plataforma de apoio clínico do Brasil!
            </Styles.Title>
          </Styles.DescriptionWrapper>
          <Styles.PricesWrapper>
            <Styles.MonthlyPriceWrapper>
              <Styles.MonthlyPrice>
                <Styles.Price>R$ {offers?.basePrice?.monthly}</Styles.Price>&nbsp;<Styles.Text>/mês</Styles.Text>
              </Styles.MonthlyPrice>
              <Styles.Text>
                Apenas R${' '}
                {(
                  Math.floor(
                    (parseFloat(offers?.basePrice?.monthly.replace(/[^0-9,]/g, '').replace(',', '.')) / 30) * 100,
                  ) / 100
                )
                  .toString()
                  .replace('.', ',')}{' '}
                por dia
              </Styles.Text>
            </Styles.MonthlyPriceWrapper>
            <Styles.YearlyPriceWrapper>
              <Styles.YearlyPrice>
                <Styles.Price>R$ {getDiscountedTotal()}*</Styles.Price>&nbsp;<Styles.Text>/ano</Styles.Text>
              </Styles.YearlyPrice>
              <Styles.Text>*Ganhe um mês gratuito</Styles.Text>
            </Styles.YearlyPriceWrapper>
          </Styles.PricesWrapper>
          <Styles.ButtonsWrapper>
            <Styles.PlansButton onClick={handlePlansButtonClick}>Ver planos</Styles.PlansButton>
            <Styles.CheckoutButton onClick={handleCheckoutButtonClick}>
              Assine agora <Icon icon="arrow-right" size={20} />
            </Styles.CheckoutButton>
          </Styles.ButtonsWrapper>
        </Styles.Content>
      </Styles.Container>
    )
  );
}
